import React, { useContext } from "react";
import MyContext from "../../../Inventory/MyContext";
import WebTemplate from "../../../API/APIServices/WebTemplate";

const DeleteModal = (props) => {

  const { TemplateData, setDroppedItems, setTemplateData, showTemporaryAlert } = useContext(MyContext)

  const deleteLocalStrg = () => {
    setDroppedItems([])
    setTemplateData({})
    handleCloseModal();
    const saveEmptyData = () => {
      var id = localStorage.getItem("templateId")

      console.log(TemplateData);
      var Emptydata = {
        JSONChildComponents: "",
        id: id,
        name: TemplateData.name,
        textContents: "",
        jsonStructure: "",
        insertQuery: null,
      }
      var data = WebTemplate.UpdateCustomizedPageTemplate(Emptydata)
      if (data) {
        showTemporaryAlert("Template deleted successfully")
      }
    }
    saveEmptyData();
  };

  const handleCloseModal = () => {
    props.handlebox();
  };

  return (
    <div>
      {/* <div className="modal-back">
        <div className="dlt-modal">
          <p className="dlt-modal-text">
            Are you sure you want to delete the project?
          </p>
          <div className="dlt-button-box">
            <div onClick={handleCloseModal} className="dlt-modal-delete-btn">
              <div className="button-wrapper">
                <div className="text" style={{ display: "flex" }}>Cancel
                  <i className="fa-solid fa-xmark dlt-modal-icon"></i>
                </div>
              </div>
            </div>

            <div onClick={deleteLocalStrg} className="dlt-modal-cancel-btn">
              <div className="button-wrapper">
                <div className="text" style={{ display: "flex" }}>
                  Delete
                  <i className="fa-solid fa-trash dlt-modal-icon"></i>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div> */}

      <div className="modal-back" >{/*onClick={props.OpenAlertBox}*/}
        <div className="variableItem-modal" style={{ backgroundColor: "white", maxWidth: "98%", minWidth: "25%", padding: "15px", top: "40%" }}>
          <div className="">
            <div className="space-between">
              <span className="">
                <i className="fa-solid fa-circle-exclamation" style={{ marginBottom: "10px", marginLeft: "3px", fontSize: "14px", color: "#757575" }}></i>&nbsp;
                <label style={{ color: "black", fontWeight: "600", }}>{"INFO"}</label> </span>
              <button
                className="crossBtn"
                type="button"
                onClick={handleCloseModal}
              > X
              </button>
            </div>
            <hr style={{ padding: "0px", margin: "0px" }} />
            <div className="desc-error mt-3" style={{ fontSize: "16px", color: "black", textAlign: "center", fontWeight: "600", padding: "20px" }}>Are you sure you want to delete this template?</div>
            <div style={{ textAlign: "end" }} className="action mt-3">
              <div onClick={handleCloseModal} className="notnow">
                {'CANCEL'}
              </div>
              <div onClick={deleteLocalStrg} className="download-error">
                {'YES'}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteModal;
